/**
 * A plain decimal string as a person reads it, digit for digit: the whole
 * part grouped with thousands separators, leading zeros of the whole part
 * and trailing zeros of the fraction dropped. "1234567.500" reads
 * "1,234,567.5", "0.001" stays "0.001".
 *
 * These are the amounts a signer reads on the last screen before a
 * signature and the rule levels an investor reads afterwards. Anything
 * that is not a plain decimal (an exponent, a sign, a word) comes back as
 * given, trimmed, so the caller never shows a guess.
 *
 * For an integer in base units, use `formatExactUnits`.
 */
export function formatExactDecimal(value: string): string {
  const trimmed = value.trim();
  const match = /^([0-9]+)(?:\.([0-9]+))?$/.exec(trimmed);
  if (!match) return trimmed;
  const whole = BigInt(match[1]!).toLocaleString('en-US');
  const fraction = (match[2] ?? '').replace(/0+$/, '');
  return fraction ? `${whole}.${fraction}` : whole;
}
